module.exports = __webpack_public_path__ + "img/Alabama outline.ea4681b7.png";